module.exports = __webpack_public_path__ + "img/1x1_center.e073a1ae.jpg";